import React from 'react'

import { cn } from '@/shared/lib/utils'

const Layout = ({
	className,
	row,
	...props
}: React.ComponentProps<'div'> & { row?: boolean }) => (
	<div
		data-slot='layout'
		className={cn(
			'flex min-h-0 flex-auto flex-col overflow-x-hidden',
			className,
			{ 'flex-row': row }
		)}
		{...props}
	/>
)
const Header = ({ className, ...props }: React.ComponentProps<'div'>) => (
	<div
		data-slot='header'
		className={cn('flex flex-none', className)}
		{...props}
	/>
)
const Footer = ({ className, ...props }: React.ComponentProps<'div'>) => (
	<div
		data-slot='footer'
		className={cn('flex flex-none', className)}
		{...props}
	/>
)
const Content = ({ className, ...props }: React.ComponentProps<'div'>) => (
	<div
		data-slot='content'
		className={cn('flex flex-auto', className)}
		{...props}
	/>
)

export { Layout, Header, Footer, Content }
